enum PaymentRemittancesStatusType {
  NOT_SENT = '',
  PENDING = '0',
  APPROVED = '1',
  DISAPPROVED = '2',
  PARTIALLY_APPROVED = '3',
  SENT = '4',
  PAID = '5',
}

export default PaymentRemittancesStatusType;
